export default __webpack_public_path__ + "static/bme-twitter-1024x512-81aa6acb4c6298d38a5fb2c677927db3.png";